import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PackageType } from '../_models/package_type';

@Injectable({
  providedIn: 'root'
})
export class PackageTypesService {
  public updatePackageTypeData = new BehaviorSubject<PackageType>(null);

  constructor(
    private http: HttpClient
  ) { }

  getAllPackageTypes(){
    return this.http.get<PackageType[]>(`${environment.apiUrl}/api/packaging_types`)
    .pipe(map(responseData =>{
      return responseData;
    })
    )
  }

  deletePackageType(packageTypeId: number){
    return this.http.delete(`${environment.apiUrl}/api/packaging_types/${packageTypeId}`);
  }

  updatePackageType(packageTypeId:number, packageType: PackageType){
    return this.http.patch<PackageType>(`${environment.apiUrl}/api/packaging_types/${packageTypeId}`,packageType);
  }

  addPackageType(packageTypes: PackageType[]){
    return this.http.post<PackageType[]>(`${environment.apiUrl}/api/packaging_types`,packageTypes);
  }

}
